import { useMediaQuery } from '@patrianna/shared-hooks'
import type { SubscriptionType } from '@patrianna/shared-patrianna-types/store/UserModule'
import type { OfferInfo } from '@patrianna-payments/shared-store/payments/types/openApiModels/OfferInfo'
import { useEffect } from 'react'

import ShopTileLarge from 'components/ShopTile/Large'
import ShopTileSmall from 'components/ShopTile/Small'
import TitleWithDivider from 'components/TitleWithDivider'
import { trackSPPlacementDisplayed } from 'src/analyticActions/common/trackPaymentSnowplow'

import classes from './styles.module.scss'

type ShopProps = {
  loggedIn: boolean
  offers: Array<OfferInfo>
  isFirstPurchaseOffer: boolean
  sweepstakeEnabled: boolean
  userVipSubscription: SubscriptionType[]
  snowplowPayFlow?: string
  snowplowPlacementName?: string
}

function Offers(props: ShopProps) {
  const matchesShopTile = useMediaQuery('md')

  useEffect(() => {
    if (props.offers.length) {
      trackSPPlacementDisplayed({
        paymentFlow: props.snowplowPayFlow,
        placementName: props.snowplowPlacementName,
        paymentProduct: 'multiple',
      })
    }
  }, [props.offers.length, props.snowplowPayFlow, props.snowplowPlacementName])

  return (
    <div>
      <TitleWithDivider title='Gold Coins Packages' />
      {props.offers?.map((i) =>
        matchesShopTile ? (
          <ShopTileSmall
            loggedIn={props.loggedIn}
            offer={i}
            key={i.code}
            sweepstakeEnabled={props.sweepstakeEnabled}
            classNames={classes.offer}
            snowplowPayFlow={props.snowplowPayFlow}
            snowplowPlacementName={props.snowplowPlacementName}
          />
        ) : (
          <ShopTileLarge
            offer={i}
            key={i.code}
            sweepstakeEnabled={props.sweepstakeEnabled}
            snowplowPayFlow={props.snowplowPayFlow}
            snowplowPlacementName={props.snowplowPlacementName}
          />
        ),
      )}
    </div>
  )
}

export default Offers
